import jquery from "jquery";
// Make jQuery available globally for WordPress plugins that expect it
window.jQuery = jquery;
window.$ = jquery;
